module.exports = __webpack_public_path__ + "img/layout.e03df397.svg";